/**
 * The availability rows a `TIME_PREFERENCE_*` block points at.
 *
 * The block's payload carries only an id, so the rendered content is a second read.
 * Cached with the default policy rather than `staleTime: 0` (what the office block
 * uses): the rows change only when the homeowner answers, and that answer arrives as a
 * realtime frame which invalidates the whole channel anyway.
 */

import { useGetTimePreferencesByTimePreferenceId } from "@birdwatch/client";

import type { DateTimePickerValue } from "@/libs/date-fns";

export function useChannelTimePreference(timePreferenceId: string) {
  return useGetTimePreferencesByTimePreferenceId({ timePreferenceId }).get({
    enabled: !!timePreferenceId,
  });
}

/**
 * `timePreferenceItems` is `unknown` on the wire (the column is JSONB and the DTO
 * declares it untyped), so the shape is narrowed here — once, in the module that owns
 * the row — rather than cast at each render site.
 */
export function toTimePreferenceSlots(value: unknown): DateTimePickerValue[] {
  if (!Array.isArray(value)) return [];
  return value as DateTimePickerValue[];
}
